export default __webpack_public_path__ + "static/media/chance.776f2436.png";